/**
 * @fileoverview Styled components for the ArcMosaico sign-in screen (AR-792)
 * @description Values extracted from arcmosaico.ai main.css: hero banner
 * mirrors .ai-photo-header, card mirrors .contact-form, eyebrow mirrors
 * .hero-eyebrow. Shell styles come from ArcAuthPage.
 */

import styled from 'styled-components'
import {
  ARC_BORDER,
  ARC_CARD_RADIUS_PX,
  ARC_CARD_SHADOW,
  ARC_NAVY,
  ARC_PURPLE,
  ARC_TEXT_MUTED,
  cardEnter,
} from 'components/ArcAuthPage'

const FORM_MAX_WIDTH_PX = 480
const CARD_ENTER_MS = 250

/** Centered form column below the header */
export const FormColumn = styled.main`
  width: 100%;
  max-width: ${FORM_MAX_WIDTH_PX}px;
  margin: 0 auto;
  padding: 0 16px 32px;
  text-align: center;
`

/** White card wrapping the form (.contact-form) */
export const FormCard = styled.div`
  background-color: #fff;
  border: 1.5px solid ${ARC_BORDER};
  border-radius: ${ARC_CARD_RADIUS_PX}px;
  box-shadow: ${ARC_CARD_SHADOW};
  padding: 28px 36px;
  text-align: left;
  animation: ${cardEnter} ${CARD_ENTER_MS}ms ease-out;

  @media (max-width: 500px) {
    padding: 28px 24px;
  }
`

/** Form wrapper */
export const Form = styled.form`
  width: 100%;
`

/** Muted subtitle under the title */
export const Subtitle = styled.p`
  font-size: 16px;
  color: ${ARC_TEXT_MUTED};
  line-height: 1.6;
  text-align: center;
  margin: 0 0 16px;
`

/**
 * Page title following the arcmosaico.ai wordmark treatment:
 * heavy weight, tight tracking, navy with the brand's "Mosaico" in purple.
 */
export const ArcTitle = styled.h1`
  font-weight: 900;
  font-size: clamp(28px, 3vw, 34px);
  letter-spacing: -1.5px;
  line-height: 1.1;
  color: ${ARC_NAVY};
  text-align: center;
  margin: 20px 0 4px;

  span {
    color: ${ARC_PURPLE};
  }
`
